import { Box, Paper, Typography } from '@mui/material';
import ActionButtons from 'components/action-buttons';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import EditFeedReserve from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/components/input-settings/feed-reserve/edit-feed-reserve';
import FeedReserve from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/components/input-settings/feed-reserve/feed-reserve';
import { useInputSettingsState } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/context/input-settings-context';
import { useUpdateOFDSettings } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/hooks/use-update-ofd-settings';
import { UpdateFeedReserveInput } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/types/ofd-settings-input.type';
import { HeaderWrapper } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/utils/styled-components';
import { useGoogleTagManager } from 'views/order-feed/features/my-supply-plan/hooks/use-google-tag-manager';

type Props = { bufferValue: number };

const PAGE_NAME_ID = 'orderFeed.ofdMySupplyPlan.inputSettings.feedReserveTab';

const FeedReserveTab: React.FC<Props> = () => {
  const [edit, setEdit] = useState(false);
  const {
    getOfdSettingsQuery: { data: ofdSettings },
    feedReserveInput,
  } = useInputSettingsState();

  const { updateFeedReserve } = useUpdateOFDSettings();
  const { createInputSettingsEvent } = useGoogleTagManager();

  const [bufferValue, setBufferValue] = useState(ofdSettings?.capacityBuffer ?? 0);

  const handleCancel = () => setEdit(false);

  const handleEdit = (edited: boolean) => setEdit(edited);

  const handleSave = () => {
    if (!feedReserveInput) return;

    updateFeedReserve.mutate(feedReserveInput, {
      onSuccess: (data) => {
        if (ofdSettings) {
          createInputSettingsEvent('save_feed_reserve', {
            oldValue1: String(ofdSettings.capacityBuffer),
            newValue1: String(feedReserveInput!.capacityBuffer),
            oldValue2: String(ofdSettings.consumptionBufferDays),
            newValue2: String(feedReserveInput!.consumptionBufferDays),
            section: 'inputSettings',
          });
        }
      },
    });
  };

  return (
    <>
      <Paper sx={{ minHeight: 600, p: 6 }}>
        <HeaderWrapper>
          <Box>
            <Typography variant="h3" fontWeight={700} mb={2}>
              <FormattedMessage id={`${PAGE_NAME_ID}.label`} />
            </Typography>
            <Typography variant="body1" mb={4}>
              <FormattedMessage id={`${PAGE_NAME_ID}.headerText`} />
            </Typography>
          </Box>
          <Box>
            <ActionButtons isEditing={edit} onEdit={handleEdit} onCancel={handleCancel} onSave={handleSave} />
          </Box>
        </HeaderWrapper>
        {edit ? (
          <EditFeedReserve bufferValue={bufferValue} newValue={setBufferValue} />
        ) : (
          <FeedReserve bufferValue={bufferValue} newValue={setBufferValue} />
        )}
      </Paper>
    </>
  );
};

export default FeedReserveTab;
